/**
 * This is the name used at PolestarApp and other components to identify the base component of the design system
 */
const dataTypeName = 'component-warehouse';
export default dataTypeName;
